import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import PrivateTxnDetail from "../../PrivateTxnDetail";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";

const PrivateDetailPopup = ({
  closePrivateDetailModal,
  private_id,
  type,
  setPrivateTxnData,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => dispatch(enableSwitcher());
  }, []);

  return (
    <div>
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle="Private Transaction Details"
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headersubtext=""
          headertextSize="font-md"
          isfullViewrequired={true}
          fullviewbtnText="Open in full view"
          fullviewbtnType="button"
          fullviewhandleFunction={() => {
            closePrivateDetailModal();
            navigate(
              `/private_transaction_dashboard/private_transaction_view_all/private_transaction_detail_page/${private_id}`,
            );
          }}
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewdisabledBgColor="var(--text-disabled)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          closeiconbtnType="button"
          closeiconhandleFunction={closePrivateDetailModal}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <PrivateTxnDetail
            private_id={private_id}
            closePrivateDetailModal={closePrivateDetailModal}
            type={type}
            setPrivateTxnData={setPrivateTxnData}
          />
        </LargePopupRedirect>
      </div>
    </div>
  );
};

export default PrivateDetailPopup;
